const KEY = 'onesignal_prompt_dismissed';

function currentUserId() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    const id = user?.id ?? user?.user_id ?? user?.pk;
    if (id == null || id === '' || id === 0) return null;
    return String(id);
  } catch {
    return null;
  }
}

/** Read-only. Missing user (logged out / auth not restored) is not a dismissal. */
export function isNotificationPromptDismissed() {
  const userId = currentUserId();
  if (!userId) return false;
  try {
    const data = JSON.parse(localStorage.getItem(KEY) || 'null');
    return data?.userId === userId && data?.dismissed === true;
  } catch {
    return false;
  }
}

export function dismissNotificationPrompt() {
  const userId = currentUserId();
  if (!userId) return;
  localStorage.setItem(KEY, JSON.stringify({ userId, dismissed: true }));
}

/** Call only from an explicit logout. Token refresh must not reach this. */
export function clearNotificationPromptDismissal() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
